<template>
  <CPanel v-show="!loading">
    <div class="row q-mb-md">
      <span class="text-h6">{{ $t('Filter Accounts') }}</span>
    </div>
    <div
      class="row inline no-wrap full-width"
      v-for="(form, formIndex) in formsComputed"
      :key="`form-${formIndex}`"
    >
      <ItemExpandable
        :defaultOpened="formIndex === forms.length - 1"
        :label="`${$t('OR')} (${$t(' Entry ')} ${formIndex + 1})`"
        group="formsGroup"
        class="full-width q-my-md"
      >
        <div class="q-py-lg q-px-xl">
          <div class="row justify-between">
            <div class="col-5 rounded-borders">
              <span class="text-h6">{{ $t('Category') }}</span>
              <div class="q-pr-xs q-pt-md">
                <CSelector
                  value="Select a Category to Add"
                  :options="getCategoryOptions(formIndex)"
                  emit-value
                  @input="category => addCategoryToForm(category, formIndex)"
                  :use-input="false"
                />
              </div>
              <div style="width: 100%">
                <q-list v-if="Object.keys(form.categories).length > 0" bordered>
                  <q-item
                    v-for="(categoryValue, categoryKey, catIndex) in form.categories"
                    :key="`${categoryKey} ${formIndex}`"
                    clickable
                    v-ripple
                    :active="forms[formIndex].activeCategory === categoryKey"
                    @click="setFocusedInput(categoryKey, formIndex)"
                    active-class="bg-gray-5"
                  >
                    <q-item-section :class="[{ 'q-py-md': !catIndex, 'q-pb-md': catIndex }]">
                      <div v-if="catIndex > 0" class="row inline justify-center no-wrap full-width">
                        <hr style="width: 42%" />
                        <span class="text-grey-5">AND</span>
                        <hr style="width: 42%" />
                      </div>
                      <q-item-label>{{ getCategoryLabel(categoryKey) }}</q-item-label>
                      <q-item-label v-if="categoryValue.length" caption>{{
                        categoryValue.join(' - ')
                      }}</q-item-label>
                    </q-item-section>
                    <q-item-section side>
                      <q-btn
                        :class="[{ 'gt-xs': true, 'q-mt-md': catIndex > 0 }]"
                        size="12px"
                        @click.stop="handleCategoryDelete(categoryKey, formIndex)"
                        flat
                        dense
                        round
                        icon="delete"
                      />
                    </q-item-section>
                    <!-- <div v-if="1" class="row inline justify-center no-wrap full-width "> -->
                  </q-item>
                </q-list>
              </div>
            </div>
            <div class="col-5 q-my-auto">
              <span class="text-h6">{{ $t('Attribute') }}</span>

              <div class="q-pr-xs q-pt-md">
                <el-select
                  v-if="!!forms[formIndex].activeCategory"
                  v-model="forms[formIndex].categories[forms[formIndex].activeCategory]"
                  :placeholder="$t(getCategoryLabel(forms[formIndex].activeCategory))"
                  multiple
                  allow-create
                  @input="val => attrChangeCallback(val, formIndex)"
                  :loading="optionsLoading"
                  filterable
                >
                  <el-option
                    v-for="(item, index) in getAttributeOptions(formIndex)"
                    :label="item"
                    :value="item"
                    :key="item + index"
                  >
                  </el-option>
                </el-select>

                <span v-else class="text-gray-6 text-h7">{{
                  $t('Please select a category first')
                }}</span>
                <!-- new-value-mode="add-unique" -->
              </div>
            </div>
          </div>
        </div>
      </ItemExpandable>
      <div v-if="formIndex !== 0">
        <q-btn
          @click="handleRemoveForm(formIndex)"
          class="q-my-md"
          size="14px"
          flat
          round
          icon="close"
        />
      </div>
      <div v-else>
        <div style="width: 42px; display: block"></div>
      </div>
    </div>
    <div class="row full-width">
      <CButton outline ref="addBtnRef" color="primary" class="q-mt-lg" @click="addANewForm">
        {{ $t('Add Filter (or)') }}
      </CButton>
    </div>
  </CPanel>
</template>
<script>
import CPanel from '@/components/uikit/CPanel';
import Checkbox from '@design-system/components/Checkbox';
import Loading from '@/components/uikit/Loading';
import CButton from '@/components/uikit/CButton';
import CSelector from '@/components/uikit/CSelector';
import ItemExpandable from '@design-system/components/ItemExpandable';

export default {
  components: {
    CPanel,
    Checkbox,
    CSelector,
    Loading,
    CButton,
    ItemExpandable,
  },
  props: ['forms', 'categoryOptions', 'optionsLoading', 'allItemsOption', 'loading'],
  computed: {
    formsComputed: {
      set(val) {
        this.$emit('update:forms', val);
      },
      get() {
        return this.forms;
      },
    },
  },
  methods: {
    getCategoryOptions(formIndex) {
      return this.categoryOptions.filter(
        item => !Object.keys(this.formsComputed[formIndex].categories).includes(item.value)
      );
    },
    addCategoryToForm(category, formIndex) {
      this.$emit('addCategoryToForm', { category, formIndex });
    },
    setFocusedInput(category, form) {
      this.formsComputed[form].activeCategory = category;
    },
    getCategoryLabel(category) {
      const found = this.categoryOptions[
        this.categoryOptions.findIndex(item => item.value === category)
      ];
      return found ? found.label : '';
    },
    handleCategoryDelete(categoryKey, formIndex) {
      this.$emit('handleCategoryDelete', { categoryKey, formIndex });
    },
    handleRemoveForm(formIndex) {
      this.$emit('handleRemoveForm', formIndex);
    },
    getAttributeOptions(formIndex) {
      const optionKey = this.getCategoryOptionKey(this.forms[formIndex].activeCategory);
      const attrOptions = this.$store.getters['reportFilters/getAttributeOptions'](optionKey);
      return attrOptions.length > 1 ? [this.allItemsOption, ...attrOptions] : attrOptions;
    },
    getCategoryOptionKey(category) {
      const found = this.categoryOptions[
        this.categoryOptions.findIndex(item => item.value === category)
      ];
      return found ? found.optionKey : null;
    },
    addANewForm() {
      this.$emit('addANewForm');
    },
    attrChangeCallback(newData, formIndex) {
      if (newData.includes(this.allItemsOption)) {
        // this.accounts = this.accountOptions;
        if (newData[newData.length - 1] === this.allItemsOption)
          this.forms[formIndex].categories[this.forms[formIndex].activeCategory] = [
            this.allItemsOption,
          ];
        else
          this.forms[formIndex].categories[this.forms[formIndex].activeCategory] = newData.filter(
            i => i !== this.allItemsOption
          );
      }
    },
  },
};
</script>
